import { createBrowserRouter } from "react-router-dom";
import { lazyImport } from "@/lib/utils";
import { publicRoutes } from "./public";
import { storeRoutes } from "./router";

// MISC
const { NotFound } = lazyImport(() => import("@/misc/not-found"), "NotFound");

export const router = createBrowserRouter([
  ...publicRoutes,
  ...storeRoutes,
  { path: "*", element: <NotFound /> },
]);
